import { useEffect, useRef } from "react";

// False once the page has unmounted, so a reply that arrives after the user
// left doesn't update it.
const useAlive = () => {
  const alive = useRef(true);
  useEffect(() => {
    alive.current = true;
    return () => {
      alive.current = false;
    };
  }, []);
  return alive;
};

export default useAlive;
